import type { ReactNode } from "react";
import { Sidebar } from "@/components/Sidebar";

export function AppLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1 pl-14">{children}</div>
    </div>
  );
}
